<template>
   <card-seplag :titulo="'Relatórios'">      
       <div class="p-col-12">   
             <table-seplag 
                :dados="tabela" 
                :exibirCabecalho="false" 
                :campos="camposTabela" 
                :hasExibirCabecalho='false'
                :paginacao="false"
            >                    
                <Column headerStyle="width: 8em" bodyStyle="text-align: center" header="Seleção" >
                    <template #body="slotProps">                        
                        <Button 
                            type="button" 
                            class="p-button-success"
                            icon="pi pi-eye" 
                            @click="abrirModalRelatorio(slotProps.data)"  
                        />
                    </template>
                </Column>
            </table-seplag>                    
            <!-- <table-seplag
            :dados.sync="relatoriosTable"
            :campos="camposRelatorios">
                <Column headerStyle="width: 8em" bodyStyle="text-align: center" header="Seleção" >
                    <template #body="slotProps">                        
                        <Button 
                            type="button" 
                            class="p-button-success"
                            icon="pi pi-eye" 
                            @click="abrirModalRelatorio(slotProps.data)"  
                        />
                    </template>
                </Column>
            </table-seplag> -->
       </div>       
        <Dialog 
            :header="nomeModal" 
            :visible.sync="exibirModalRelatorio" 
            :modal="true" 
            :contentStyle="'min-width:60rem;min-height: 30rem;'"
        >  
            <card-seplag v-if="tipoRelatorioSelecionado && tipoRelatorioSelecionado==1">
                <Rotulo nome="Órgão" cols='12'>
                    <Dropdown v-model="orgaoSelecionado" :options="orgaos" optionLabel="descOrgao" placeholder="Selecione..."  :filter="true" @change="carregaUnidades()"  />
                </Rotulo>                
                <Rotulo nome="Unidades" cols='12' v-if="orgaoSelecionado && unidades">
                    <!-- <Dropdown v-model="unidadeSelecionada" :options="unidades" optionLabel="descricao" placeholder="Selecione..."  :filter="true"   /> -->
                     <Dropdown v-model="unidadeSelecionada" :options="unidades" optionLabel="descricao" placeholder="Selecione..."  :filter="true" >
                        <template #value="slotProps">
                            <div class="country-item country-item-value" v-if="slotProps.value">
                                <div>{{slotProps.value.descricao}}</div>
                            </div>
                            <span v-else>
                                {{slotProps.placeholder}}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <div class="country-item">
                                <div v-tooltip.top="slotProps.option.descUnidade">{{slotProps.option.idenUnidade}} - {{slotProps.option.siglUnidade}}</div>
                            </div>
                        </template>
                    </Dropdown>
                </Rotulo>    
                <Rotulo nome="Ciclo" cols='12 6'>
                    <Dropdown v-model="ciloSelecionado" :options="listaCiclos" optionLabel="descCiclo" placeholder="Selecione..." />
                </Rotulo>                          
                <Rotulo nome="Status" cols='12' v-if="orgaoSelecionado && unidades">
                    <Dropdown v-model="status" :options="statusRecadastramento" optionLabel="name" placeholder="Selecione..."  />
                </Rotulo>
                
                
                <div class="p-col-12">
                    <div class="p-grid p-fluid">
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-danger" label="Cancelar"  @click="fecharFiltro()"  icon="pi pi-times" iconPos="left" />
                        </div>
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-success" label="Filtrar"  icon="pi pi-check" iconPos="left" @click="relatorioAcompanhamentoUnidade()"/>
                        </div>
                    </div>
                </div>
            </card-seplag>
            <card-seplag v-if="tipoRelatorioSelecionado && tipoRelatorioSelecionado==2">
                <Rotulo nome="Tipo do Filtro" cols='12 6'>
                    <Dropdown v-model="tipoSelecionado" :options="tipoFiltro" optionLabel="name" placeholder="Selecione..." />
                </Rotulo>                 
                <Rotulo nome="Matrícula" cols='12 6' v-if="tipoSelecionado && tipoSelecionado.code==1">
                    <InputText type="text" v-model="matriculaFiltro"  />
                </Rotulo>              
                <Rotulo nome="CPF" cols='12 6' v-if="tipoSelecionado && tipoSelecionado.code==2">
                    <InputText type="text" v-model="cpfFiltro"  />
                </Rotulo>  
                <Rotulo nome="Ciclo" cols='12 6'>
                    <Dropdown v-model="ciloSelecionado" :options="listaCiclos" optionLabel="descCiclo" placeholder="Selecione..." />
                </Rotulo>                 
                <div class="p-col-12">
                    <div class="p-grid p-fluid">
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-danger" label="Cancelar"  @click="fecharFiltro()"  icon="pi pi-times" iconPos="left" />
                        </div>
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-success" label="Filtrar"  icon="pi pi-check" iconPos="left" @click="relatorioAcompanhamentoServidor()"/>
                        </div>
                    </div>
                </div>
            </card-seplag>
           <!--  <card-seplag v-if="tipoRelatorioSelecionado && tipoRelatorioSelecionado == 11">            
                <Rotulo nome="CPF" cols='12 6' >
                    <InputText type="text" v-model="matriculaFiltro"  />
                </Rotulo>     
                <Rotulo nome="Ciclo" cols='12 6'>
                    <Dropdown v-model="ciclo2021" :options="listaCiclos" optionLabel="descCiclo" placeholder="Selecione..." />
                </Rotulo>
                <div class="p-col-12" v-if="listaDocumentos.length >0">                    
                    <table-seplag 
                        :dados.sync="listaDocumentos" 
                        :exibirCabecalho="false" 
                        :campos="camposTabelaDocumentos" 
                        :hasExibirCabecalho='false'
                        :paginacao="false"
                    >            
                        <Column headerStyle="width: 8em" bodyStyle="text-align: center" header="Seleção" >

                            <template #body="slotProps">                        
                                <Button 
                                    type="button" 
                                    class="p-button-success"
                                    icon="pi pi-eye" 
                                    @click="abrirModalVisualizacaoDocumentos(slotProps.data.idenArquivo)"  
                                />
                            </template>
                        </Column>
                    </table-seplag>  
                </div>                
                <div class="p-col-12">
                    <div class="p-grid p-fluid">
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-danger" label="Cancelar"  @click="fecharFiltro()"  icon="pi pi-times" iconPos="left" />
                        </div>
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-success" label="Filtrar"  icon="pi pi-check" iconPos="left" @click="relatorioVisualizacaoDocumentos()"/>
                        </div>
                    </div>
                </div>
            </card-seplag> -->
            <card-seplag v-if="tipoRelatorioSelecionado && (tipoRelatorioSelecionado == 9 || tipoRelatorioSelecionado == 10)">            
                <Rotulo nome="Ciclo" cols='12 6'>
                    <Dropdown v-model="ciloSelecionado" :options="listaCiclos" optionLabel="descCiclo" placeholder="Selecione..." />
                </Rotulo>
                <div class="p-col-12">
                    <div class="p-grid p-fluid">
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-danger" label="Cancelar"  @click="fecharFiltro()"  icon="pi pi-times" iconPos="left" />
                        </div>
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-success" label="Filtrar" v-if="tipoRelatorioSelecionado == 9"  icon="pi pi-check" iconPos="left" @click="relatorioAcompanhamentoGeral()"/>
                            <Button class="p-button-success" label="Filtrar" v-if="tipoRelatorioSelecionado == 10"  icon="pi pi-check" iconPos="left" @click="relatorioAcompanhamentoGeralEmpresaPublica()"/>
                        </div>
                    </div>
                </div>
            </card-seplag>
            <card-seplag v-else-if="tipoRelatorioSelecionado && tipoRelatorioSelecionado >= 3">            
                <Rotulo nome="Matrícula" cols='12 6' >
                    <InputText type="text" v-model="matriculaFiltro"  />
                </Rotulo>     
                <Rotulo nome="Ciclo" cols='12 6'>
                    <Dropdown v-model="ciloSelecionado" :options="listaCiclos" optionLabel="descCiclo" placeholder="Selecione..." />
                </Rotulo>                
                <div class="p-col-12">
                    <div class="p-grid p-fluid">
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-danger" label="Cancelar"  @click="fecharFiltro()"  icon="pi pi-times" iconPos="left" />
                        </div>
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-success" label="Filtrar"  icon="pi pi-check" iconPos="left" @click="relatorioAcompanhamentoServidor()"/>
                        </div>
                    </div>
                </div>
            </card-seplag>
        </Dialog>     
        <ExibirPDF  v-if="pdfBase64" v-model="exibirPDFDocumento" :tamanhoTela="'70.vw'" :alturaTela="'30.vw'" :tituloTela="nomeModalPDF" :pdfElement="pdfBase64"  />
    </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import ExibirPDF from '@/template/CardExibirPDF.vue'
import TableSeplag from '@/template/TableSeplag.vue';
import { baseApiUrl } from '@/config/global'
export default {
    name: "gerenciaRelatorios",
    components: { CardSeplag, ExibirPDF, Rotulo, TableSeplag },
    data: function(){        
		return {
            exibirPDFDocumento: false,
            pdfBase64:"",
            nomeModalPDF: "MODAL PDF",
            orgaos: [],
            ciclo: [],
            orgaoSelecionado: null,
            unidades: [],
            listaDocumentos: [],
            unidadeSelecionada: null,
            tipoFiltro:[
                {name:"Matrícula",code:1},                
                {name:"CPF (somente número)",code:2}
            ],
            statusRecadastramento: [
                {name:"TODOS",code:null}, 
                {name:"NÃO INICIADO",code:"NAO_INICIADO"}, 
                {name:"EM ANDAMENTO",code:"EM_ANDAMENTO"}, 
                {name:"AGUARDANDO VALIDAÇÃO",code:"AGUARDANDO_VALIDACAO"},
                {name:"CONCLUIDO",code:"CONCLUIDO"}
            ],
            status: null,
            matriculaFiltro:null,
            cpfFiltro: null,
            tipoSelecionado: null,
            ciloSelecionado: null,
            ciclo2021: null,
            tipoRelatorioSelecionado: null,

            exibirModalRelatorio: false,
            nomeModal: 'Modal Relatorio',
            camposTabela:[
                {nome: 'nome', titulo:'Nome do relatório'}
            ],
            camposTabelaDocumentos: [
                {nome:'tipoDocumento.descTipoDocumento', titulo:''}
            ],
            relatorios: [
                {nome:"RELATÓRIO DE ACOMPANHAMENTO POR UNIDADE",tipoRelatorio:1,nomeRole:"RELATORIO_UNIDADE_VIEW"},
                {nome:"RELATÓRIO DE ACOMPANHAMENTO POR PESSOA",tipoRelatorio:2,nomeRole:"RELATORIO_PESSOA_VIEW"},
                {nome:"RELATÓRIO DE ACOMPANHAMENTO GERAL",tipoRelatorio:9,nomeRole:"RELATORIO_GERAL_VIEW"},
                {nome:"RELATÓRIO DE ACOMPANHAMENTO GERAL EMPREGADOS PÚBLICOS",tipoRelatorio:10,nomeRole:"RELATORIO_EMPREGADOS_PUBLICOS_VIEW"},
                {nome:"RELATÓRIO DE FORMAÇÃO ACADÊMICA DO SERVIDOR",tipoRelatorio:3,nomeRole:"RELATORIO_FORMACAO_ACADEMICA_VIEW"},
                {nome:"RELATÓRIO DE DADOS PESSOAIS DO SERVIDOR",tipoRelatorio:4,nomeRole:"RELATORIO_DADOS_PESSOAIS_VIEW"},
                {nome:"RELATÓRIO DE ENDEREÇO DOS SERVIDORES",tipoRelatorio:5,nomeRole:"RELATORIO_DADOS_ENDERECO_VIEW"},
                {nome:"RELATÓRIO DE DEPENDENTES DOS SERVIDORES",tipoRelatorio:6,nomeRole:"RELATORIO_DADOS_DEPENDENTES_VIEW"},
                {nome:"RELATÓRIO DE CAPACITAÇÃO DOS SERVIDORES",tipoRelatorio:7,nomeRole:"RELATORIO_DADOS_CAPACITACAO_VIEW"},
                {nome:"RELATÓRIO DE DOCUMENTOS DOS SERVIDORES",tipoRelatorio:8,nomeRole:"RELATORIO_DADOS_DOCUMENTOS_VIEW"},
                {nome:"VISUALIZAÇÃO DOS DOCUMENTOS DE IDENTIFICAÇÃO COM FOTO DOS SERVIDORES",tipoRelatorio:11,nomeRole:"RELATORIO_IDENTIFICACAO_FOTO_VIEW"},
            ],
            dadosRelatorios:[],
            camposRelatorios:[
                {nome:'nomeRole', titulo:'Nome Role'},
                {nome:'data.nomeExibir', titulo:"Nome Relatório"}
            ],
            relatoriosTable:[],
            tabela:[],
            autorizacoes : this.$store.getters.getUser.contaAcesso.configAcesso.listaAutorizacoes,
            listaCiclos : []      
		}
    },
    methods:{
        async carregarDados(){         
            this.listarRelatoriosPorPerfil() 
            let isAdminCentral = false
            let isAdminSetorial = false
            let isAdminApoio = false
            this.autorizacoes.forEach(dadosAuth => {
                if(dadosAuth.nomeRole=="RECAD_ADMIN_CENTRAL"){
                    isAdminCentral = true
                    
                } else if(dadosAuth.nomeRole=="RECAD_ADMIN_SETORIAL") {
                    isAdminSetorial = true
                } else if(dadosAuth.nomeRole=="RECAD_ADMIN_APOIO") {
                    isAdminApoio = true
                }
            })

            if(isAdminCentral) {
                this.buscarCiclos(`${baseApiUrl}/ciclos/all`).then(res=>{
                    this.listaCiclos = res
                })
            } else if (isAdminSetorial || isAdminApoio) {
                this.buscarCiclos(`${baseApiUrl}/ciclos/listarCicloAberto`).then(res=>{
                    this.listaCiclos = res
                })
            }else{ //Condicional temporaria, por isso está sendo feita assim. 
                this.buscarCiclos(`${baseApiUrl}/ciclos/listarCicloAberto`).then(res=>{
                    this.listaCiclos = res
                })
            }
                
            await this.$http.get(`${baseApiUrl}/chefiapessoas/orgaosAcesso/${this.$store.getters.getCicloPessoa[0].vinculosAtivos[0].numrMatricula}`).then(res =>{
                this.orgaos = res.data
            })               
            
        },
        
        async buscarCiclos(url){
            let ciclo = await this.$http.get(url).then(res =>{
                let cicloAux = res.data.filter(element => {
                    return element.exercicio.ano == 2021
                })
                if(cicloAux.length > 0){
                    this.ciclo2021 = cicloAux[0]
                }
                return res.data
            }) 

            return ciclo
        },
        carregaUnidades(){
            this.unidades =  []
            this.unidadeSelecionada = null
            this.$http.get(`${baseApiUrl}/unidades/orgao/${this.orgaoSelecionado.idenOrgao}`).then(res =>{
                this.unidades = res.data
            })
        },
        fecharFiltro(){
            this.tipoRelatorioSelecionado = null
            this.orgaoSelecionado = null
            this.unidadeSelecionada = null
            this.tipoSelecionado = null
            this.matriculaFiltro = null
            this.cpfFiltro = null           
            this.listaDocumentos = []
            this.status = null
            this.ciloSelecionado = null
            this.exibirModalRelatorio = false
        },
        abrirModalRelatorio(dado){
            if(dado.tipoRelatorio==9){
                //this.relatorioAcompanhamentoGeral()
                this.tipoRelatorioSelecionado = dado.tipoRelatorio
                this.nomeModal = 'Filtros para o '+dado.nome 
                this.exibirModalRelatorio = true
            }else if(dado.tipoRelatorio==10){
                //this.relatorioAcompanhamentoGeralEmpresaPublica()
                this.tipoRelatorioSelecionado = dado.tipoRelatorio
                this.nomeModal = 'Filtros para o '+dado.nome 
                this.exibirModalRelatorio = true
            }else if(dado.tipoRelatorio==11){                
                this.listaDocumentos = []
                this.matriculaFiltro = null
                this.tipoRelatorioSelecionado = dado.tipoRelatorio
                this.nomeModal = dado.nome 
                this.exibirModalRelatorio = true
            }else{
                this.tipoRelatorioSelecionado = dado.tipoRelatorio
                this.nomeModal = 'Filtros para o '+dado.nome 
                this.exibirModalRelatorio = true
            }
        },
        relatorioAcompanhamentoUnidade(){
            if(this.validaCicloSelecionado()) {
                let bodyRelatorio = {     
                    matriculaUsuario: Number(this.$store.getters.getCicloPessoa[0].vinculosAtivos[0].numrMatricula),
                    idenOrgao: this.orgaoSelecionado? this.orgaoSelecionado.idenOrgao : null,
                    idenUnidade: this.unidadeSelecionada? this.unidadeSelecionada.codgSeap : null,
                    status: this.status? this.status.code : null,
                    idenCiclo: this.ciloSelecionado.idenCiclo
                }
                this.$http.post(`${baseApiUrl}/relatorios/recadastropororgao`,JSON.stringify(bodyRelatorio)).then(res =>{
                    this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                    this.nomeModalPDF = "RELATÓRIO DE ACOMPANHAMENTO - "+this.orgaoSelecionado.descOrgao
                    // this.fecharFiltro()
                    this.exibirPDFDocumento = true
                })
            }
        },
        relatorioAcompanhamentoServidor(){
            let bodyRelatorio = null
            if(this.validaCicloSelecionado()){
                if(this.tipoSelecionado && this.tipoSelecionado.code==1){
                    bodyRelatorio = {                      
                        matriculaPesquisa: this.matriculaFiltro,
                        matriculaUsuario: this.$store.getters.getCicloPessoa[0].vinculosAtivos[0].numrMatricula,
                        idenCiclo: this.ciloSelecionado.idenCiclo,
                        cpf: null        
                    }
                }            
                if(this.tipoSelecionado && this.tipoSelecionado.code==2){
                    bodyRelatorio = {                         
                        matriculaPesquisa: null,
                        matriculaUsuario: this.$store.getters.getCicloPessoa[0].vinculosAtivos[0].numrMatricula,
                        idenCiclo: this.ciloSelecionado.idenCiclo,
                        cpf: this.cpfFiltro
                    }
                }      
                if(this.tipoRelatorioSelecionado && this.tipoRelatorioSelecionado>=3){
                    bodyRelatorio = {           
                        idenCiclo: this.ciloSelecionado.idenCiclo,
                        numrMatricula: this.matriculaFiltro
                    }
                }
                if(bodyRelatorio){
                    
                    if(this.tipoSelecionado && this.tipoSelecionado.code<=2){
                        this.$http.post(`${baseApiUrl}/relatorios/recadastroauditoria`,JSON.stringify(bodyRelatorio)).then(res =>{
                            this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                            this.nomeModalPDF = "RELATÓRIO DE AUDITORIA"
                            // this.fecharFiltro()
                            this.exibirPDFDocumento = true
                        })
                    }else if(this.tipoRelatorioSelecionado && this.tipoRelatorioSelecionado==3){
                        this.$http.post(`${baseApiUrl}/relatorios/recadastroformacaoacademica`,JSON.stringify(bodyRelatorio)).then(res =>{
                            this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                            this.nomeModalPDF = "RELATÓRIO DE AUDITORIA - FORMAÇÃO ACADÊMICA DO SERVIDOR"
                            // this.fecharFiltro()
                            this.exibirPDFDocumento = true
                        })
                    }else if(this.tipoRelatorioSelecionado && this.tipoRelatorioSelecionado==4){
                        this.$http.post(`${baseApiUrl}/relatorios/recadastrorecdadospessoais`,JSON.stringify(bodyRelatorio)).then(res =>{
                            this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                            this.nomeModalPDF = "RELATÓRIO DE AUDITORIA - DADOS PESSOAIS DO SERVIDOR"
                            // this.fecharFiltro()
                            this.exibirPDFDocumento = true
                        })
                    }else if(this.tipoRelatorioSelecionado && this.tipoRelatorioSelecionado==5){
                        this.$http.post(`${baseApiUrl}/relatorios/recadastroenderecoservidores`,JSON.stringify(bodyRelatorio)).then(res =>{
                            this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                            this.nomeModalPDF = "RELATÓRIO DE AUDITORIA - ENDEREÇO DOS  "
                            // this.fecharFiltro()
                            this.exibirPDFDocumento = true
                        })
                    }else if(this.tipoRelatorioSelecionado && this.tipoRelatorioSelecionado==6){
                        this.$http.post(`${baseApiUrl}/relatorios/recadastrodependentesservidores`,JSON.stringify(bodyRelatorio)).then(res =>{
                            this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                            this.nomeModalPDF = "RELATÓRIO DE AUDITORIA - DEPENDENTES DOS SERVIDORES "
                            // this.fecharFiltro()
                            this.exibirPDFDocumento = true
                        })
                    }else if(this.tipoRelatorioSelecionado && this.tipoRelatorioSelecionado==7){
                        this.$http.post(`${baseApiUrl}/relatorios/recadastrocapacitacoesservidores`,JSON.stringify(bodyRelatorio)).then(res =>{
                            this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                            this.nomeModalPDF = "RELATÓRIO DE AUDITORIA - CAPACITAÇÃO DOS SERVIDORES"
                            // this.fecharFiltro()
                            this.exibirPDFDocumento = true
                        })
                    }else if(this.tipoRelatorioSelecionado && this.tipoRelatorioSelecionado==8){
                        this.$http.post(`${baseApiUrl}/relatorios/recadastrodocumentosservidores`,JSON.stringify(bodyRelatorio)).then(res =>{
                            this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                            this.nomeModalPDF = "RELATÓRIO DE AUDITORIA - DOCUMENTOS DOS SERVIDORES"
                            // this.fecharFiltro()
                            this.exibirPDFDocumento = true
                        })
                    }else if(this.tipoRelatorioSelecionado && this.tipoRelatorioSelecionado==11){
                        this.$http.post(`${baseApiUrl}/relatorios/recadastroarquivosservidores`,JSON.stringify(bodyRelatorio)).then(res =>{
                            this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                            this.nomeModalPDF = "RELATÓRIO DE AUDITORIA - ARQUIVOS ENVIADOS"
                            // this.fecharFiltro()
                            this.exibirPDFDocumento = true
                        })
                    }
                    
                }else{                
                    this.$toast.add({severity:'error', summary: 'Erro ao identificar o tipo do filtro', detail:'Ocorreu um erro ao identificar o tipo do filtro, porfavor selecione um tipo antes de filtrar o relatório!', life: 10000});
                }
            }
        },
        relatorioVisualizacaoDocumentos(){
            if(!this.matriculaFiltro || !this.ciclo2021){
                this.$toast.add({severity:'error', summary: 'Campo obrigatório não preenchido', detail:'Por favor selecione o ciclo e preencha a matrícula!', life: 10000});
                return
            }
            this.$http.get(`${baseApiUrl}/relatorios/recadastroarquivosservidores/${this.matriculaFiltro}/${this.ciclo2021.idenCiclo}`).then(res =>{
               if(res.data.length > 1 ){
                   this.listaDocumentos = res.data;
               }else if(res.data.length == 1 ){
                   this.abrirModalVisualizacaoDocumentos(res.data[0].idenArquivo)
               }else{
                this.listaDocumentos = []
                this.$toast.add({severity:'error', summary: 'Erro ao filtrar os documentos', detail:'Não foi encontrado nem um documento validado do tipo Carteira Nacional de Habilitação, Registro Geral e Documento Nacional de Identificação!', life: 10000});
               }
            })
        },
        abrirModalVisualizacaoDocumentos(idenArquivo){
            this.$http.get(`${baseApiUrl}/arquivosrecad/download/${idenArquivo}`).then(res =>{
                this.pdfBase64 = res.data
                this.nomeModalPDF = "AUDITORIA - DOCUMENTOS DE IDENTIFICAÇÃO COM FOTO"
                this.listaDocumentos = []
                // this.fecharFiltro()
                this.exibirPDFDocumento = true
            })
        },
        relatorioAcompanhamentoGeral(){
            //this.fecharFiltro()
            if(this.validaCicloSelecionado()) {
                this.$http.get(`${baseApiUrl}/relatorios/recadastrogeral/${this.$store.getters.getCicloPessoa[0].vinculosAtivos[0].numrMatricula}/${this.ciloSelecionado.idenCiclo}`,this.ciloSelecionado.idenCiclo).then(res =>{
                    this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                    this.nomeModalPDF = "RELATÓRIO DE ACOMPANHAMENTO GERAL"
                    this.exibirPDFDocumento = true
                })
            }

            
        },
        relatorioAcompanhamentoGeralEmpresaPublica(){
            //this.fecharFiltro()            
            if(this.validaCicloSelecionado()) {
                let bodyRelatorio = {
                    idenOrgao: null,
                    idenCiclo : this.ciloSelecionado.idenCiclo
                }
                this.$http.post(`${baseApiUrl}/relatorios/recadastroemppublico`,JSON.stringify(bodyRelatorio)).then(res =>{
                    this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                    this.nomeModalPDF = "RELATÓRIO DE ACOMPANHAMENTO GERAL EMPRESA PÚBLICA"
                    this.exibirPDFDocumento = true
                })
            }
        },
        listarRelatoriosPorPerfil() {
            this.$http.get(`${baseApiUrl}/seguranca/autorizacaos/listaAutorizacaoRelatorio`).then(res => {
                this.dadosRelatorios = res.data
                this.dadosRelatorios.forEach(dados =>{
                    this.$store.getters.getUser.contaAcesso.authorities.forEach(dados2 =>{
                        if(dados.nomeRole == dados2.nomeRole){
                        this.relatoriosTable.push(dados) 
                    }              
                    })                   
                })
                this.relatorios.forEach(resultado =>{
                    this.relatoriosTable.forEach(resultado2 =>{
                        if(resultado.nomeRole == resultado2.nomeRole){
                            this.tabela.push(resultado)
                        }
                    })
                })               
            })         
        },
        validaCicloSelecionado(){
            
            if(!this.ciloSelecionado || !this.ciloSelecionado.idenCiclo){
                this.$toast.add({severity:'error', summary: 'Ciclo não informado', detail:'Por favor selecione o ciclo desejado', life: 10000});
                return false
            } else {
                return true
            }
        }
    },
    mounted(){        
        this.carregarDados()
    },
    computed: {
        tempermicao(){
            let possuiPermissao = false
            let perfilUsers = this.$store.getters.getUser.contaAcesso.authorities
            if( perfilUsers && perfilUsers.length > 0){                 
                let permissao = perfilUsers.filter(function (element){ 
                    return element.nomeRole == 'ADMINISTRADOR CENTRAL - RECADASTRO'
                })
                if(permissao && permissao.length > 0){
                        possuiPermissao = true
                }
            }
            return possuiPermissao
        }
    }
}
</script>
<style scoped>
   .p-tooltip{
       min-width: 2rem
   } 
.text-center{
    text-align: center;
}
.cursor-poiter{
    cursor: pointer;
}
</style>